module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "glitch-wrapper"
  }, [_c('div', {
    staticClass: "glitch",
    style: ({
      color: _vm.color,
      background: _vm.background
    }),
    attrs: {
      "data-text": _vm.text
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f7dbe55","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Glitch.vue
// module id = 12
// module chunks = 0